var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container__full-width rooms-listing"},[_c('h1',{staticClass:"centered"},[_vm._v(_vm._s(_vm.organizationName))]),_vm._v(" "),_c('ul',_vm._l((_vm.rooms),function(room){return _c('li',[_c('a',{attrs:{"href":'/' + _vm.orgId + '?room=' + room.id}},[_vm._v("\n        "+_vm._s(room.roomName)+"\n      ")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50748fa0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Directory.vue
// module id = nSQr
// module chunks = 1